import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb, Col, Empty, Row, Spin, Typography } from 'antd';
import ToolCard from '../components/ToolCard';
import { tasksAPI } from '../services/api';
import { useLanguage } from '../store/LanguageContext';
import { usePageSeo } from '../utils/usePageSeo';

const { Title, Paragraph, Text } = Typography;

const TaskPage: React.FC = () => {
  const { slug = '' } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const zh = language === 'zh-CN';
  const [loading, setLoading] = useState(true);
  const [task, setTask] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    tasksAPI
      .getBySlug(slug)
      .then((res) => {
        if (!cancelled) setTask(res.data?.task || null);
      })
      .catch(() => {
        if (!cancelled) setTask(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const name = task ? (zh ? task.name_zh || task.name_en : task.name_en) : slug;
  const intro = task
    ? zh
      ? task.description_zh || task.description_en || ''
      : task.description_en || ''
    : '';
  const title = zh ? `AI 做${name}` : `AI for ${name}`;

  usePageSeo({
    title,
    description: intro || title,
    path: `/task/${slug}`,
  });

  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!task) {
    return (
      <div style={{ padding: 48 }}>
        <Empty description={zh ? '任务不存在' : 'Task not found'} />
      </div>
    );
  }

  const tools = task.tools || [];

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 16px 48px' }}>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[
          { title: <a onClick={() => navigate('/')}>{zh ? '首页' : 'Home'}</a> },
          { title: <a onClick={() => navigate('/tools')}>{zh ? '工具库' : 'Tools'}</a> },
          { title: name },
        ]}
      />
      <Title level={2}>{title}</Title>
      {intro ? <Paragraph type="secondary">{intro}</Paragraph> : null}
      <Text type="secondary">{zh ? `${tools.length} 个候选` : `${tools.length} candidates`}</Text>
      {tools.length === 0 ? (
        <Empty style={{ marginTop: 48 }} description={zh ? '暂无挂接工具' : 'No tools linked'} />
      ) : (
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          {tools.map((tool: any) => (
            <Col key={tool.id || tool.slug} xs={24} sm={12} md={8} lg={6}>
              <ToolCard tool={tool} />
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default TaskPage;
